import { fork, put, takeLatest } from 'redux-saga/effects';
import { OPEN_MODAL } from '../../../iwModals/Modals.actions';
import { MANUAL_PAYMENT } from './ManualPaymentModal.actions';

export const manualPaymentModalSagasWorkers = [fork(manualPayment)];

function* manualPayment() {
    yield takeLatest(MANUAL_PAYMENT, function* () {
        yield put({
            type: OPEN_MODAL,
            id: 'ManualPaymentModal'
        });
    });
}
